import { HausbankFieldTypes } from 'hausbank/inquiry/fields';

type HausbankPurposeFieldTypes = HausbankFieldTypes['financingNeedPage']['purposeSection'];

export const mapHausbankPurpose = (values: HausbankPurposeFieldTypes) => ({
  purpose_kind: values.purposeKind,
  project_description: values.projectDescription,
});
